import { ComponentValue } from '../sceneDataSchema';

export function stringConverter(value: ComponentValue): string | null {
  if (value === '' || value === null || value === undefined) {
    return '';
  }

  if (typeof value !== 'string') {
    return value.toString();
  }

  return value;
}
